export default __webpack_public_path__ + "static/managed-c451e2dea852f5fd1f4de0197f97fe0a.png";